import React, { useRef } from "react";
import { TriangleAlert, Loader, X } from "lucide-react";
import Spacing from "../Spacing";
import { Drawer } from 'vaul';
import { getPractice } from "../../helpers";

export default function ConfirmationFileUploadModal(
  {
    openModal=false,
    setOpenModal=()=>{},
    errorMessage = null,
    uploadDisabled = false,
    uploadLoader = false,
    modalAction = () => {},
    previousScrollPosition=0,
    setErrorMessage = () => {},
    fileName = null,
    selectedFileName = null,
    requiredColumns = null,
    uploadType = null
  }
) {
  const dropdownRef = useRef(null);

  const fileListLabel = (filesArr) => {
    if (!filesArr?.length) return "";
    if (filesArr.length === 1) return filesArr[0].name;
    return filesArr.map((f) => f.name).join(", ");
  };

  const handleDrawerClose = () => {
    setOpenModal(false);
    setErrorMessage(null);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={openModal} onOpenChange={setOpenModal}>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 small" onPointerDownOutside={(e) => e.preventDefault()} onInteractOutside={(e) => e.preventDefault()}>
            <Drawer.Title className="sr-only">Delete Record</Drawer.Title>
            <Drawer.Description className="sr-only">Delete a recorded data</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_2 docpro_style_auto">
              <div className="docpro_modal relative">
                <div className="docpro_deleteboxbox modal_height_100">
                  <div>
                    <div className="docpro_iconbox_icon docpro_badge_red">
                      <TriangleAlert width={50} height={50} />
                    </div>
                    <Spacing lg="20" sm="20" />
                    <div className="docpro_iconbox_right">
                      <h3 className="docpro_fs_20">Are you Sure?</h3>
                      <p className="docpro_mb_0 docpro_fs_16">
                        {fileName ? (
                          <>You want to upload <span className="docpro_green_color font-semibold">{!uploadType ? fileName.length > 1 ? fileListLabel(fileName) : 'this ICD & CPT' : fileName?.name || 'this IPA'}</span> {!uploadType ? fileName?.length === 1 ? 'file' : 'files' : 'file'} data?</>
                        ) : (
                          <>You want to upload <span className="docpro_green_color font-semibold">{getPractice("account_name")}</span> data to the default location: <span className="docpro_green_color font-semibold">{getPractice("location_name")}</span>?</>
                        )}
                      </p>
                      <Spacing lg="32" sm="32" />
                    </div>
                  </div>
                  <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                    <button
                      className="docpro_bordered_btn docpro_fw_600 size_lg"
                      style={{ padding: '12px 30px' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleDrawerClose();
                      }}
                    >
                      No
                    </button>
                    <button
                      disabled={uploadDisabled}
                      className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg docpro_btn_green`}
                      style={{ padding: '12px 30px' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        modalAction();
                      }}
                    >
                      Yes
                      {uploadLoader && (
                        <span className="docpro_loading">
                          <Loader width={20} height={20} />
                        </span>
                      )}
                    </button>
                  </div>
                </div>

                {errorMessage && (
                  <div className="docpro_badge_danger badge_overright">
                    <div>
                      <button
                        className="docpro_close_btn"
                        onClick={handleDrawerClose}
                      >
                        <X />
                      </button>
                      <div>
                        <p className="docpro_mb_0">{errorMessage}</p>
                        {requiredColumns && (
                          <p className="mt-1 docpro_mb_0">
                            <strong>Required Columns:</strong> {requiredColumns}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {uploadDisabled && (
                  <div className="docpro_badge_loader badge_overright">
                    <div>
                      <button
                        className="docpro_close_btn"
                        style={{ color: '#cb1d63' }}
                        onClick={handleDrawerClose}
                      >
                        <X />
                      </button>
                      <span className="docpro_loading">
                        <Loader width={50} height={50} color="#646464" />
                      </span>
                      <div>
                        <p className="docpro_fs_18 docpro_fw_600 mb-1">Processing...</p>
                        <p className="docpro_fs_16 docpro_mb_0 docpro_green_color">{!uploadType ? selectedFileName : fileName?.name}</p>
                        <p className="docpro_mb_0 docpro_red_color">Please do not close the process.</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
